function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.455,
    height: 9.198,
    viewBox: "0 0 12.455 9.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.743 7.157a.829.829 0 0 0-1.2 0l-6.429 6.429-2.657-2.657a.849.849 0 0 0-1.2 1.2l3.257 3.257a.829.829 0 0 0 1.2 0l7.029-7.029a.829.829 0 0 0 0-1.2z",
    transform: "translate(-4.8 -6.645)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".4px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.3e521bd4df73d6b0717aee02cc42136f.svg";
export { ForwardRef as ReactComponent };